<template>
    <div>
      <h4>{{ $t('advanced.stats_panel_placeholder') }}</h4>
    </div>
  </template>
  <script>
  export default { name: "StatsPanel" }
  </script>
  